export const GET_NOTIFICATION_DATA = "GET_NOTIFICATION_DATA"
